import { QueryClient } from '@tanstack/react-query';

const STALE_TIME_MS = 30 * 1000; // 30s – avoid refetch on every mount

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: STALE_TIME_MS,
    },
  },
});
